// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"paymentLoader__loaderWrapper__MjA75","logo":"paymentLoader__logo__Z_c1c","loader":"paymentLoader__loader__deTr9","status":"paymentLoader__status__xGZo0"};